import { AlertTriangle, CheckCheck, Copy } from "lucide-react";
import { Progress } from "@/components/ui/progress";

const Count = ({ label, value, cls, testid }) => (
  <div className="rounded-xl bg-muted/60 px-3 py-2" data-testid={testid}>
    <p className="text-[10px] uppercase tracking-widest text-muted-foreground font-mono">{label}</p>
    <p className={`font-mono font-semibold text-lg ${cls || ""}`}>{value || 0}</p>
  </div>
);

export const BatchProgress = ({ batch }) => {
  const c = batch.counts || {};
  const total = batch.count;
  const done = (c.rendered || 0) + (c.failed || 0);
  const pct = Math.round((done / total) * 100);
  const active = ["planning", "rendering"].includes(batch.status);
  return (
    <div className="card-surface p-6 space-y-4" data-testid="batch-progress">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          {active && <span className="h-2.5 w-2.5 rounded-full bg-primary pulse-dot" />}
          <h2 className="text-lg font-semibold tracking-tight" data-testid="batch-status">
            {batch.status === "planning" ? "Writing hooks & captions…" : batch.status === "rendering" ? `Rendering ${done}/${total}` : batch.status === "completed" ? "Batch complete" : "Completed with errors"}
          </h2>
        </div>
        <span className="font-mono text-sm text-muted-foreground" data-testid="batch-percent">{pct}%</span>
      </div>
      <Progress value={pct} className="h-2" />
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
        <Count label="Queued" value={c.queued} testid="count-queued" />
        <Count label="Processing" value={c.processing} cls="text-primary" testid="count-processing" />
        <Count label="Rendered" value={c.rendered} cls="text-primary" testid="count-rendered" />
        <Count label="Failed" value={c.failed} cls={c.failed ? "text-destructive" : ""} testid="count-failed" />
        <Count label="Approved" value={c.approved} testid="count-approved" />
        <Count label="Near-dupes" value={c.near_duplicates} cls={c.near_duplicates ? "text-amber-500" : ""} testid="count-duplicates" />
      </div>
      {batch.capability && !batch.capability.sufficient && (
        <p className="flex items-start gap-2 text-xs text-amber-500" data-testid="batch-capability-warning"><AlertTriangle size={14} className="shrink-0 mt-0.5" /> {batch.capability.warning}</p>
      )}
      {batch.status === "rendering" && batch.copy_ai_count !== undefined && (
        <p className="flex items-center gap-2 text-xs text-muted-foreground"><Copy size={12} /> AI copy generated for {batch.copy_ai_count}/{total}{batch.copy_ai_count < total ? " (rest use transcript fallbacks)" : ""}</p>
      )}
      {batch.status === "completed" && <p className="flex items-center gap-2 text-xs text-primary"><CheckCheck size={14} /> All renders finished. Approve the keepers and head to Compose.</p>}
    </div>
  );
};
